import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = { class: "flex gap-x-1 text-sm leading-5 font-medium mb-2 p-1" }
const _hoisted_3 = { class: "bg-gray-200 rounded-md px-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "enrolment trigger", -1)
const _hoisted_5 = { class: "w-full h-full bg-white rounded-2xl flex flex-col text-sm leading-5 font-normal items-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "py-6 w-full flex flex-col justify-center items-center p-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "The event trigger to enter the workflow:", -1)
const _hoisted_8 = {
  key: 0,
  class: "w-full mt-4 mx-4 bg-gray-100 shadow-sm p-1 rounded-xl"
}
const _hoisted_9 = { class: "rounded-lg shadow py-2.5 w-full bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-x-2 justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-medium text-primary-color-700 bg-primary-color-100 w-fit px-1 py-0.5 rounded" }, " Property Value Changed "),
  /*#__PURE__*/_createElementVNode("p", null, ":")
], -1)
const _hoisted_11 = { class: "flex justify-center text-sm text-center leading-5 font-semibold text-gray-700 pt-2" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "bg-primary-color-50 px-2 py-1 text-primary-color-800 font-semibold rounded-md mt-2" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex flex-col justify-center items-center p-4 text-gray-900 gap-y-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Trigger workflow "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "everyday")
], -1)
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = {
  key: 1,
  class: "flex flex-col justify-center items-center p-4 text-gray-900 gap-y-3"
}
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = {
  key: 2,
  class: "py-6 w-full flex flex-col justify-center items-center p-6"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Enrolled from workflows:", -1)
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "py-6 w-full flex flex-col justify-center items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "items-center text-center w-[281px] text-gray-500 mb-5" }, " Choose the triggers that decide how a person enters this workflow. ", -1)

import { computed, onMounted, ref } from "vue"
import { LightningBoltIcon } from "@heroicons/vue/solid"
import { TrashIcon } from "@heroicons/vue/outline"
import GgmsButton from "@/components/GgmsButton.vue"
import EnrolmentTriggersSidebar from "@/components/workflows/sidebar/trigger/EnrolmentTriggersSidebar.vue"
import ToolbarNode from "@/components/workflows/ToolbarNode.vue"
import EnrollFromDetails from "@/components/workflows/EnrollFromDetails.vue"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import { ContactActivityTriggerNodeType, ScheduleTriggerNodeType, TriggerNodeType } from "@/shared/models/workflow"
import { FiltersGroup } from "../../shared/models/filter"
import { useWorkflowStore } from "../../stores/workflow"

interface Props {
    id?: string
    text?: string
    event?: string
    note?: { text?: string; lastEdited?: string }
    type?: string
    selectedData?: { name: string; label: string }[]
    showDeleteButton?: boolean
    enrolledFrom?: string[]
    branches?: { filtersGroups: FiltersGroup[] }[]
    firstValue?: string
    secondValue?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TriggerNode',
  props: {
    id: {},
    text: {},
    event: {},
    note: {},
    type: {},
    selectedData: {},
    showDeleteButton: { type: Boolean, default: true },
    enrolledFrom: {},
    branches: {},
    firstValue: {},
    secondValue: {}
  },
  emits: ["update:note", "removeNode", "openTriggerModal", "clickOnNode", "changeAction"],
  setup(__props: any, { emit: __emit }) {

const workflowStore = useWorkflowStore()
const props = __props

const emits = __emit

const toolbarStatus = ref("emptyClosed")
const localNote = ref(props.note)
const isNoteVisible = ref(false)
const timeOfDay = ref()

const nodeTitle = computed(() => {
    if (props.enrolledFrom) {
        return "Manual"
    }
    if (props.type === TriggerNodeType.schedule) {
        return "Schedule"
    }
    return "Contact"
})

let hideTimeout: ReturnType<typeof setTimeout>
function handleMouseEnter() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function changeAction() {
    emits("changeAction", {
        componentName: EnrolmentTriggersSidebar.__name,
    })
}

function handleMouseLeave(event: MouseEvent) {
    hideTimeout = setTimeout(() => {
        if (
            ((event.relatedTarget as Element) && (event.relatedTarget as Element).classList.contains("toolbar-node")) ||
            toolbarStatus.value !== "emptyClosed" ||
            localNote.value?.text?.length !== 0
        ) {
            return
        }
        isNoteVisible.value = false
    }, 300)
}

function handleMouseEnterToolbarNode() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function updateNote(note: { text?: string; lastEdited?: string }) {
    emits("update:note", note)
    localNote.value = note
}

onMounted(() => {
    if (localNote.value?.text?.length !== 0) {
        isNoteVisible.value = true
    }
    if (workflowStore.scheduleTime) {
        timeOfDay.value = workflowStore.scheduleTime
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolbarNode, {
      id: "targetElement",
      class: "toolbar-node",
      note: _ctx.note,
      isNoteVisible: isNoteVisible.value,
      status: toolbarStatus.value,
      onMouseenter: handleMouseEnterToolbarNode,
      onMouseleave: handleMouseLeave,
      "onUpdate:note": updateNote,
      "onUpdate:status": _cache[0] || (_cache[0] = ($event: any) => (toolbarStatus.value = $event)),
      "onUpdate:noteVisible": _cache[1] || (_cache[1] = ($event: any) => (isNoteVisible.value = $event))
    }, null, 8, ["note", "isNoteVisible", "status"]),
    _createElementVNode("div", {
      class: "p-2 bg-gray-100 w-[400px] !rounded-2xl border border-gray-200 group hover:outline hover:outline-2 hover:outline-gray-400 hover:shadow-lg nodrag nopan",
      onMouseenter: handleMouseEnter,
      onMouseleave: handleMouseLeave,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clickOnNode')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(LightningBoltIcon), { class: "h-4 w-4" }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(nodeTitle.value), 1),
          _hoisted_4
        ]),
        (_ctx.showDeleteButton)
          ? (_openBlock(), _createBlock(_unref(TrashIcon), {
              key: 0,
              class: "hidden group-hover:block w-5 h-5 mb-2 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('removeNode')), ["prevent","stop"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.type === _unref(TriggerNodeType).contactActivity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.event === _unref(ContactActivityTriggerNodeType).propertyValueChanged)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectedData ? _ctx.selectedData.map((data) => data.label)?.join(", ") : ""), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(convertTriggerEvent)(_ctx.event ? _ctx.event : "")), 1)
                  ]))
            ]))
          : (_ctx.type === _unref(TriggerNodeType).schedule)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.event === _unref(ScheduleTriggerNodeType).timeOfDay)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("p", null, [
                          _createTextVNode(" at "),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.firstValue), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Trigger workflow on "),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.firstValue), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(" at "),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.secondValue), 1)
                      ])
                    ]))
              ]))
            : (_ctx.enrolledFrom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(EnrollFromDetails, { enrolledFrom: _ctx.enrolledFrom }, null, 8, ["enrolledFrom"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(GgmsButton, {
                      class: "w-full px-6",
                      "style-type": "primary",
                      type: "button",
                      onClick: _withModifiers(changeAction, ["prevent","stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Set up trigger/s")
                      ]),
                      _: 1
                    })
                  ])
                ]))
      ])
    ], 32)
  ], 64))
}
}

})